
import { defineComponent, ref, watch, onMounted, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'

import * as qiniu from 'qiniu-js'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    name: 'Pop',
    props: ['data'],
    emits: ['uploaderror', 'uploaded'],
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const fileNode = ref()
        const isWap = ref<boolean>(false)
        // 文件列表数据
        const imgList = ref<any[]>([])
        // 传给父组件的文件列表
        const uploadImgs = ref<any[]>([])

        // 上传成功的文件名称
        let uploadFileNames = ref<any[]>([])
        // 上传控件
        let uploadControls:any = []
        // cdn文件列表
        let imgs:any = []

        // 父组件传入的老的文件数据,重置初始数据
        if (props.data.imgs) {
            imgs = props.data.imgs.split(',')
            const names: any = props.data.fileNames ? props.data.fileNames.split(',') : ''
            if (names) {
                uploadFileNames.value = names
            }   
            imgs.forEach((img, idx) => {
                imgList.value.push({
                    url: img,
                    percent: 100,
                    name: names ? names[idx] : ''
                })
            })
        }
        // 获取七牛上传token
        const getToken = () => {
            return _this.proxy.$request('/upload/token', {
                aid: $store.state.aid,
                token: $store.state.userInfo ? $store.state.userInfo.token || 'none' : 'none'
            })
        }
        // 文件上传
        const allFileLen = ref<number>(0)
        let filesLen = 0
        const upload = (e) => {
            const files = e.target.files
            filesLen = files.length
            if (props.data.maxLen > 1 && imgs.length >= props.data.maxLen) {
                context.emit('uploaderror', {
                    formIndex: props.data.formIndex,
                    name: props.data.name,
                    errorType: 'limit'
                })
                return
            }
            if (!files && !filesLen) {
                return
            }
            context.emit('uploaderror', {
                formIndex: props.data.formIndex,
                name: props.data.name,
                errorText: ' '
            })
            // 不能超过最大上传个数
            filesLen = filesLen + imgList.value.length < props.data.maxLen ? filesLen : props.data.maxLen - imgList.value.length
            // 如果超过最大上传个数,且最大上传个数为1,则直接替换掉之前的上传
            if (props.data.maxLen === 1 && filesLen <= 0) {
                filesLen = 1
                imgList.value = []
            } 
            // 处理上传列表,并上传文件
            const accepts = props.data.accept.split(',')
            let index = imgList.value.length - 1
            for(let i = 0; i < filesLen; i++) {
                // 文件格式是否正确
                if (accepts.indexOf('.' + files[i].name.split('.')[1]) < 0) {
                    context.emit('uploaderror', {
                        formIndex: props.data.formIndex,
                        name: props.data.name,
                        errorType: 'format'
                    })
                    allFileLen.value++
                    continue
                // 文件大小是否超过限制
                } else if (files[i].size > props.data.size * 1024 * 1024) {
                    context.emit('uploaderror', {
                        formIndex: props.data.formIndex,
                        name: props.data.name,
                        errorType: 'size'
                    })
                    allFileLen.value++
                    continue
                }
                // 文件预览地址
                let url = '' 
                if (props.data.preview) {
                    if (window.createObjectURL != undefined) {
                        url = window.createObjectURL(files[i])
                    } else if (window.URL != undefined) {
                        url = window.URL.createObjectURL(files[i])
                    } else if (window.webkitURL != undefined) {
                        url = window.webkitURL.createObjectURL(files[i])
                    }
                }  
                // 获取七牛上传token
                getToken().then((data) => {
                    imgList.value.push({
                        url: url,
                        percent: 0,
                        name: files[i].name
                    })
                    index++
                    const uploadControl = qiniuUpload(files[i], data.token, index)
                    uploadControls.push(uploadControl)
                }) 
            }
        }
        // 七牛上传
        const qiniuUpload = (file, token, index) => {
            const observable = qiniu.upload(file, null, token, {}, {})
            const subscription = observable.subscribe({
                next (res) {
                    imgList.value[index].percent = res.total ? Math.ceil(res.total.percent) : 0
                },
                error (err: any) {
                    allFileLen.value++
                    if(err.code == 413) {
                        context.emit('uploaderror', {
                            formIndex: props.data.formIndex,
                            name: props.data.name,
                            errorType: 'size'
                        })
                    } else if(err.code == 401) {
                        context.emit('uploaderror', {
                            formIndex: props.data.formIndex,
                            name: props.data.name,
                            errorText: '页面过期，请重新打开'
                        })
                    } else {
                        context.emit('uploaderror', {
                            formIndex: props.data.formIndex,
                            name: props.data.name,
                            errorText: '网络错误，上传失败~'
                        })
                    }
                },
                complete (res) {
                    allFileLen.value++
                    imgList.value[index].percent = 100
                    imgs[index] = `https://yunyingcdn.thecover.cn/${res.key}`
                    uploadFileNames.value[index] = imgList.value[index].name
                    uploadImgs.value = JSON.parse(JSON.stringify(imgs))
                }
            })
            return subscription
        }

        watch(() => allFileLen.value, (val) => {
            if (val >= filesLen) {
                fileNode.value.value = ''
            }
        })

        watch(() => uploadImgs.value, (val) => {
            context.emit('uploaded', {
                formIndex: props.data.formIndex,
                name: props.data.name,
                fileName: props.data.fileName,
                url: val.join(','),
                fileNames: props.data.fileName ? uploadFileNames.value.join(',') : ''
            })
        })
        // 移除上传数据
        const remove = (index) => {
            imgList.value.splice(index, 1)
            imgs.splice(index, 1)
            uploadFileNames.value.splice(index, 1)
            uploadImgs.value = JSON.parse(JSON.stringify(imgs))   
        }
        // 上传过程中,停止上传
        const stopUpload = (index: number) => {
            uploadControls[index - (imgList.value.length - uploadControls.length)].unsubscribe()
            remove(index)
        }

        onMounted(() => {
            isWap.value = COVERAPP.Attribute.isMb()
        })

        return {
            fileNode,
            isWap,
            upload,
            imgList,
            remove,
            stopUpload
        }

    }
})
